export default function isValidAmount(s: string | number) {
  if (typeof s === 'number') return true
  const found = String(s).search(/^(\d*\.?\d+?)$/)
  return found > -1
}
